import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    SRC: {
        id: 'techDoc.priorityType.option.src',
        defaultMessage: 'SRC'
    },
    VOR: {
        id: 'techDoc.priorityType.option.vor',
        defaultMessage: 'VOR'
    },
    OTS_ACTIS: {
        id: 'techDoc.priorityType.option.otsActisSolution',
        defaultMessage: 'OTS/ACTIS solution'
    },
});

export default messages;
